import { DATA_PRELOADER, LAYOUT_HORIZONTAL, LAYOUT_MODE, LAYOUT_POSITION, LAYOUT_WIDTH, SIDEBAR_COLOR, SIDEBAR_IMAGE, SIDEBAR_SIZE, SIDEBAR_VIEW, TOPBAR } from "src/app/layouts/layout.model";

export class ThemeModel {
    layout: string = LAYOUT_HORIZONTAL;
    mode: string = LAYOUT_MODE;
    width: string = LAYOUT_WIDTH;
    position: string = LAYOUT_POSITION;
    topbar: string = TOPBAR;
    size: string = SIDEBAR_SIZE;
    sidebarView: string = SIDEBAR_VIEW;
    sidebar: string = SIDEBAR_COLOR;
    sidebarImage: string = SIDEBAR_IMAGE;
    preLoader:string = DATA_PRELOADER;
}
